

















































































import { Component, Vue, Prop, Watch, Ref } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';
import { SessionActionsKeys, SessionActionsPayload } from '../../store/types/session';
import { BoardGettersReturns } from '../../store/types/board';
import { isURL } from '@/utils';

@Component({})
export default class CreateSession extends Vue {
  @Prop(Number) preselectedBoard!: number | null;
  @Prop(Boolean) selectedOnly?: boolean;

  @Getter boardList!: BoardGettersReturns['boardList'];

  @Action(SessionActionsKeys.CREATE_SESSION) createSession!: (
    payload: SessionActionsPayload['CREATE_SESSION']
  ) => Promise<void>;

  @Ref('createSessionForm') sessionForm!: Vue;

  get boards() {
    return [{ id: null, name: 'New board' }, ...this.boardList];
  }

  dialog = false;
  validSessionForm = true;

  public newSession = {
    boardId: this.preselectedBoard,
    name: '',
    externalConferenceLink: '',
  };

  @Watch('dialog')
  setNewSession() {
    this.newSession = {
      boardId: this.preselectedBoard,
      name: '',
      externalConferenceLink: '',
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if (this.sessionForm) (this.sessionForm as any).resetValidation();
  }

  sessionDataValidations = {
    name: [(v: string) => !!v || 'Session name is required'],
    externalConferenceLink: [(v: string) => !v || isURL(v) || 'External Video Conference must be a valid link'],
  };

  async createNewSession() {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if ((this.sessionForm as any).validate()) {
      await this.createSession(this.newSession);
      this.dialog = false;
    }
  }
}
